<template>
  <div>
    <vue-simple-suggest
      v-model="chosen"
      display-attribute="name"
      value-attribute="id"
      :list="getSuggestionList"
      @select="onSuggestSelect"
    >
    </vue-simple-suggest>
  </div>
</template>

<script>
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css"; // Optional CSS

export default {
  components: {
    VueSimpleSuggest,
  },
  data() {
    return {
      chosen: "",
      selected: null,
    };
  },
  methods: {
    onSuggestSelect(suggest) {
      this.selected = suggest;
      this.$emit("nameSelected", suggest);
    },
    getSuggestionList() {
      return this.$client
        .get("/api/customer/searchCustomer?name=" + this.chosen)
        .then((response) => {
          var users = response.data.value;

          return users.map(function(a) {
            var user = { id: a.id, name: a.firstName + " " + a.lastName };

            return user;
          });
        });
    },
  },
};
</script>
<style></style>
